'use client';

import { c as _c } from "react/compiler-runtime";
import { lookup } from '@cruz-com/lookup';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { ListBox, Text } from '@/components';
import { radiusOption } from '@/settings';
type DefaultQuery = {
  zip_code?: string;
  radius?: number;
  sort_id?: number;
};
type Props = {
  defaultQuery: DefaultQuery;
  onSortIdChangedAction: (val: number) => void;
  onLocationChangedAction: (val: {
    zip_code?: string;
    radius?: number;
  }) => void;
};
export function VehicleFilter2(t0) {
  const $ = _c(42);
  const {
    defaultQuery,
    onSortIdChangedAction,
    onLocationChangedAction
  } = t0;
  let t1;
  if ($[0] !== defaultQuery) {
    t1 = _.pick(defaultQuery, ["zip_code", "radius"]);
    $[0] = defaultQuery;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [loc, setLoc] = useState(t1);
  let t2;
  if ($[2] !== defaultQuery) {
    t2 = () => {
      setLoc(_.pick(defaultQuery, ["zip_code", "radius"]));
    };
    $[2] = defaultQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = defaultQuery?.zip_code;
  const t4 = defaultQuery?.radius;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = [t3, t4];
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t2, t5);
  let t6;
  if ($[7] !== defaultQuery.radius || $[8] !== defaultQuery.zip_code || $[9] !== loc || $[10] !== onLocationChangedAction) {
    t6 = function locChanged(name, value) {
      let updateValue = value;
      if (name === "zip_code") {
        updateValue = _.toString(value).replace(/\D/g, "");
      }
      const d = {
        ...loc,
        [name]: updateValue
      };
      setLoc(d);
      const zLen = _.size(d.zip_code);
      if (d.zip_code === defaultQuery.zip_code && d.radius === defaultQuery.radius) {
        return;
      }
      if (zLen === 5 || zLen === 0 && _.size(loc.zip_code) > 0) {
        if ((d.radius || 0) > 0 || (d.radius || 0) < 0 && (loc.radius || 0) > 0) {
          onLocationChangedAction(d);
        }
      }
    };
    $[7] = defaultQuery.radius;
    $[8] = defaultQuery.zip_code;
    $[9] = loc;
    $[10] = onLocationChangedAction;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const locChanged = t6;
  let t7;
  if ($[12] !== onSortIdChangedAction) {
    t7 = function sortIdChanged(value_0) {
      onSortIdChangedAction(value_0);
    };
    $[12] = onSortIdChangedAction;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const sortIdChanged = t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <legend className="sr-only">Location Filter</legend>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <label htmlFor="zip_code_2" className="vehicle-s2-label mr-2">Zip Code:</label>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = loc?.zip_code || "";
  let t11;
  if ($[16] !== locChanged) {
    t11 = e => locChanged("zip_code", e.target.value);
    $[16] = locChanged;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <div className="flex items-center">{t9}<div className="w-[65px]"><Text inline={true} compact={true} name="zip_code" id="zip_code_2" maxLength={5} className="w-[5ch]" type="tel" value={t10} onChange={t11} onFocus={_temp} /></div></div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="vehicle-s2-label mr-2">Radius:</span>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = loc?.radius || -1;
  let t15;
  if ($[22] !== locChanged) {
    t15 = val => {
      locChanged("radius", _.toNumber(val));
    };
    $[22] = locChanged;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15) {
    t16 = <div className="flex items-center">{t13}<div className="w-[140px] md:w-[130px]"><ListBox inline={true} compact={true} option={radiusOption} value={t14} onChange={t15} /></div></div>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t12 || $[28] !== t16) {
    t17 = <fieldset className="flex gap-x-4">{t8}{t12}{t16}</fieldset>;
    $[27] = t12;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <legend className="sr-only">Sorting</legend>;
    t19 = <span className="vehicle-s2-label">Sort By:</span>;
    $[30] = t18;
    $[31] = t19;
  } else {
    t18 = $[30];
    t19 = $[31];
  }
  let t20;
  if ($[32] !== defaultQuery.sort_id) {
    t20 = _.toNumber(defaultQuery?.sort_id || 1);
    $[32] = defaultQuery.sort_id;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== sortIdChanged) {
    t21 = val_0 => {
      sortIdChanged(_.toNumber(val_0));
    };
    $[34] = sortIdChanged;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t20 || $[37] !== t21) {
    t22 = <fieldset className="flex items-center gap-x-3">{t18}{t19}<ListBox inline={true} className="min-w-[200px]" option={lookup.vehicle.sortOption} value={t20} onChange={t21} /></fieldset>;
    $[36] = t20;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t17 || $[40] !== t22) {
    t23 = <section aria-label="Zip Code, Radius, and Sorting" className="vehicle-s2-filter">{t17}{t22}</section>;
    $[39] = t17;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  return t23;
}
function _temp(e_0) {
  return e_0.target.select();
}